var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 4.76245H2.625C1.8 4.76245 1.125 5.43745 1.125 6.26245V17.775C1.125 18.6 1.8 19.275 2.625 19.275H21.375C22.2 19.275 22.875 18.6 22.875 17.775V6.26245C22.875 5.43745 22.2 4.76245 21.375 4.76245ZM2.625 5.51245H21.375H21.4125L12.6 10.9875C12.225 11.2125 11.775 11.2125 11.4375 10.9875L2.475 5.51245C2.5125 5.51245 2.55 5.51245 2.625 5.51245ZM11.025 11.6625C11.325 11.85 11.6625 11.925 12 11.925C12.3375 11.925 12.675 11.85 12.975 11.6625L13.4625 11.3625L20.9625 18.525H2.8875L10.5375 11.3625L11.025 11.6625ZM1.875 6.26245C1.875 6.18745 1.875 6.14995 1.9125 6.07495L9.9 10.95L2.0625 18.225C1.95 18.1125 1.875 17.925 1.875 17.7375V6.26245ZM22.125 17.7375C22.125 17.9625 22.0125 18.1875 21.8625 18.3L14.1 10.95L22.05 5.99995C22.0875 6.07495 22.0875 6.18745 22.0875 6.26245V17.7375H22.125Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeAlt);
export default __webpack_public_path__ + "static/media/envelope-alt.fe9f5c33eb9faa10b29adcd8be7e624f.svg";
export { ForwardRef as ReactComponent };